module.exports = __webpack_public_path__ + "img/Dinner.a0db7a40.jpeg";